import React from "react";
import PropTypes from "prop-types";

export default class Manufacturer extends React.Component {
    render(){
        const itemImg = `${localStorage.getItem("restUrl")}/pub/media/${this.props.image}`;

        return(
            <a href={`/manufacturers/${this.props.url_key}`} title={this.props.page_title}>
                <img src={itemImg} onError={this.addDefaultSrc} />
            </a>
        );
    }
    addDefaultSrc(e){
        e.target.src = "/images/image-not-found.png";
    }
}

Manufacturer.propTypes = {
    page_title: PropTypes.string,
    url_key: PropTypes.string,
    image: PropTypes.string
};
